var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#DCD6CB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6167_116543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 14.625V4.5C5.625 4.20163 5.74353 3.91548 5.9545 3.7045C6.16548 3.49353 6.45163 3.375 6.75 3.375H11.25C11.5484 3.375 11.8345 3.49353 12.0455 3.7045C12.2565 3.91548 12.375 4.20163 12.375 4.5V14.625M5.625 14.625H12.375M5.625 14.625H4.5C4.20163 14.625 3.91548 14.5065 3.7045 14.2955C3.49353 14.0845 3.375 13.7984 3.375 13.5V10.125C3.375 9.82663 3.49353 9.54048 3.7045 9.3295C3.91548 9.11853 4.20163 9 4.5 9H5.625M12.375 14.625H13.5C13.7984 14.625 14.0845 14.5065 14.2955 14.2955C14.5065 14.0845 14.625 13.7984 14.625 13.5V8.4375C14.625 8.13913 14.5065 7.85298 14.2955 7.642C14.0845 7.43103 13.7984 7.3125 13.5 7.3125H12.375M7.875 5.625H10.125M7.875 7.875H10.125M7.875 10.125H10.125M7.875 12.375H10.125",
    stroke: "#141414",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6167_116543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(2.25 2.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingFill);
export default __webpack_public_path__ + "static/media/building-fill.8ea10bb9448f30f8b94e43f6b28e6a46.svg";
export { ForwardRef as ReactComponent };